'use client';
import React, { useState, useEffect, useContext } from 'react'
import useMousePosition from './utils/useMousePosition';
import { motion, useMotionValue } from 'motion/react';
import {ServicesCopy } from '@/app/copywritting';
import { CursorContext } from '@/app/context/cursorContext';

interface Props {
  containerRef?: React.RefObject<HTMLDivElement>;
  className?: string;
  height?: number;
}

const ServicesArea = (props: Props) => {
  
  const { containerRef } = props;
  const [scrollProgress, setScrollProgress] = useState(0);
  const [scrollColorChange, setScrollColorChange] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const { x, y } = useMousePosition();
  const size = isHovered ? 300 : 40;

  const [cursorType, setCursorType] = useContext<any>(CursorContext)
  const [cursorPosition, setCursorPosition] = useState<any>({ x: 1000, y: 1000 })


  useEffect(() => {

    if (window.matchMedia(`(max-width: 768px)`).matches) {
    } else {
    }

      const handleScroll = () => {
        const target = containerRef?.current || document.documentElement;  
        const { scrollTop, scrollHeight, clientHeight } = target;
        const totalHeight = scrollHeight - clientHeight;
        const progress = (scrollTop / totalHeight) * 100;
        if (progress >= 23) {
          setScrollColorChange(true)
        } else {
          setScrollColorChange(false)
        }

      }

    const moveCursor2 = (e: MouseEvent) => {
      setCursorPosition({
        x: e.clientX - 0.5 * window.innerWidth,
        y: e.clientY - 0.5 * window.innerHeight,
      });
    }
    

    window.addEventListener("scroll", handleScroll)
    window.addEventListener('mousemove', moveCursor2)
    return () => { window.removeEventListener("scroll", handleScroll), window.removeEventListener('mousemove', moveCursor2) }
    }, [])

  const variants: any = {
    hovered: {
      opacity: 1,
      transition: {
        duration: 0.1,
        ease: 'easeInOut',
      },
    },
    default: {
      opacity: 0,
      transition: {
        duration: 0.1,
        ease: 'easeInOut',
      },
    }
  }

  return (
    <section className='flex flex-col md:pt-30 md:pb-15'>
        <div className='flex flex-col place-items-center pb-10'>
          <h3 className="text-lg md:text-3xl font-bold md:pt-10 md:pb-1 tracking-tighter uppercase">{ServicesCopy.title}</h3>
          <p className={`w-100 md:w-[40%] text-md md:text-xl text-center px-5 text-[#6d6e73] md:text-[#f8f8ff] leading-none md:leading-[1.32rem] transition-colors duration-500 ease-in-out ${scrollColorChange ? "md:text-black" : "md:text-white"} `}>{ServicesCopy.mainText}</p>
        </div>
        <div className='flex flex-col place-items-center text-center '>
          <div className='flex flex-col item-center text-center'
            onPointerEnter={() => setCursorType("hovered")}
            onPointerLeave={() => setCursorType("default")}
          >
              {ServicesCopy.textListMod.map((service, index) => (
                <h1
                  key={service[0]}
                  id={service[0]}
                  className={`md:h-[148px] ${service[1] ? "text-[2.77rem] md:text-huge-alt md:leading-huge-alt" : "text-5xl md:text-huge md:leading-huge"} font-bold tracking-tighter uppercase leading-services-mobile md:leading-huge transition-colors hover:bg-black delay-50 duration-500 ease-in-out`}
                >
                  {service[0]}
                </h1>
              ))}
          </div>
        <motion.div className='cursorMask flex flex-col bg-[#0b0d15] absolute item-center text-center'
            onPointerEnter={() => setCursorType("hovered")}
            onPointerLeave={() => setCursorType("default")}
            animate={cursorType == "hovered" ? "hovered" : "default"}
            style={{
              maskPosition: `${cursorPosition.x}px ${cursorPosition.y}px`,
              WebkitMaskPositionX: cursorPosition.x,
              WebkitMaskPositionY: cursorPosition.y,
            }}
            variants={variants}
            transition={{ type: 'tween', ease: "backOut", duration: 0.5 }}
          >
            {ServicesCopy.textListMod.map((service, index) => (
              <h1
                key={service[0]}
                id={service[0]}
                className={`md:h-[148px] ${service[1] ? "text-[2.77rem] md:text-huge-alt md:leading-huge-alt" : "text-5xl md:text-huge md:leading-huge"} font-bold tracking-tighter uppercase leading-services-mobile md:leading-huge text-[#f8f8ff]`}
              >
                {service[0]}
              </h1>
            ))}
          </motion.div>
        </div>
        
    </section>
  )
}

export default ServicesArea